module.exports = __webpack_public_path__ + "static/media/booster.002ef26e.png";